import queryString from "query-string";
import services from "../../../../services";
import $ from 'jquery';

let data = [];

const generateId = data =>
    data.reduce((acc, current) => Math.max(acc, current.ProductID), 0) + 1;

export const insertItem = item => {
    item.ProductID = generateId(data);
    item.inEdit = false;
    item.Columns = [];
    item.IDAutoDetalhe = 0;
    data.unshift(item);
    return data;
};

export const deleteAll = () => {
    data = [];
    return data;
};
export const dataGet4 = async () => {
    return data;
};
export const getItems4 = async () =>  {
    console.log("services4")
    if(window.location.search != ""){
        var queryParams = queryString.parse(window.location.search)
        var  token = queryParams.idAuto
        var  dataToken = {"idAuto": token}
        var Detalhes = await services.apiCall.requestApi(
            "/Fiscalizacao/GetAutoDetalhe",
            dataToken,
            "get"
        ); 
       
            for (let i = 0; i < Detalhes.autoGridSelosGarantia.length ; i++) {
                var idTipoSelo = Detalhes.autoGridSelosGarantia[i].idTipoSelo;
                var SerieSelo = Detalhes.autoGridSelosGarantia[i].serieSelo;
                var IDRegistoSelo = Detalhes.autoGridSelosGarantia[i].idRegistoSelo;
                var IntervaloSelo = Detalhes.autoGridSelosGarantia[i].intervaloSelo;
                var NumeroSeloInicial = Detalhes.autoGridSelosGarantia[i].numeroSeloInicial;
                var NumeroSeloFinal = Detalhes.autoGridSelosGarantia[i].numeroSeloFinal;
                var QuantidadeSelos = Detalhes.autoGridSelosGarantia[i].quantidadeSelos;
                var SelosSegurancaSelagemSelosGarantia = Detalhes.autoGridSelosGarantia[i].selosSegurancaSelagemSelosGarantia;
                var EtiquetasSegurancaSelosGarantia = Detalhes.autoGridSelosGarantia[i].etiquetasSegurancaSelosGarantia;
                var SinetesSelosGarantia = Detalhes.autoGridSelosGarantia[i].sinetesSelosGarantia;
                var TipoSelo = Detalhes.autoGridSelosGarantia[i].tipoSelo;
                var linha = Detalhes.autoGridSelosGarantia[i].linha
                var selosGarantia = []
                var etiquetasGarantia = []
                var contaCorrenteDesc =  Detalhes.autoGridSelosGarantia[i].contaCorrenteDesc;
                var idContaCorrente =  Detalhes.autoGridSelosGarantia[i].idContaCorrenteEng;
                var correlativa =  Detalhes.autoGridSelosGarantia[i].correlativaEng;
                var idRotulo = Detalhes.autoGridSelosGarantia[i].idRotuloEng;
                var idRegistoProduto = Detalhes.autoGridSelosGarantia[i].idRegistoProduto
            
                
                if($("#tipo_auto :selected").val() == "6" || $("#tipo_auto :selected").val() == "15"){
                    if(selosGarantia.length == 0){
                        SelosSegurancaSelagemSelosGarantia.map((SelosSegurancaSelagemSelosGarantia) => (
                            selosGarantia.push(SelosSegurancaSelagemSelosGarantia.idSelo)
                        
                        ));
                    }
                    if(etiquetasGarantia.length == 0){
                        EtiquetasSegurancaSelosGarantia.map((EtiquetasSegurancaSelosGarantia) => (
                            etiquetasGarantia.push(EtiquetasSegurancaSelosGarantia.idEtiqueta)
                        
                        ));
                    }

                    data.push({ 
                        TipoSelo : {text: TipoSelo, value: idTipoSelo},
                        Serie_selosGarantia : {text: SerieSelo, value: IDRegistoSelo},
                        intervalosDisponiveis_selosGarantia : {text: IntervaloSelo, value: IDRegistoSelo},
                        Nr_Selo_inicial_selosGarantia : NumeroSeloInicial,
                        Nr_Selo_final_selosGarantia: NumeroSeloFinal,
                        Quantidade_selosGarantia: QuantidadeSelos,
                        SelosSeguranca : selosGarantia,
                        Etiquetas_selagem_selosGarantia : etiquetasGarantia,
                        Sinetes_selosGarantia: SinetesSelosGarantia,
                        ProductID: linha,
                        IDAutoDetalhe: Detalhes.autoGridSelosGarantia[i].idAutoDetalhe,
                        Discontinued: false,
                        Columns: [],
                        inEdit: false
                    })
                    //// FIM selagem (grid1)
                } else if($("#tipo_auto :selected").val() == "9"){
                    if(correlativa != null){
                        var valor = correlativa.split("-")[3]
                    }else{
                        var valor = ""
                    }
                    data.push({ 
                      
                        TipoSelo : {text: TipoSelo, value: idTipoSelo},
                        Serie_selosGarantia : {text: SerieSelo, value: IDRegistoSelo},
                        intervalosDisponiveis_selosGarantia : {text: IntervaloSelo, value: IDRegistoSelo},
                        Nr_Selo_inicial_selosGarantia : NumeroSeloInicial,
                        Nr_Selo_final_selosGarantia: NumeroSeloFinal,
                        Quantidade_selosGarantia: QuantidadeSelos,
                        Produto_Selos : {text: contaCorrenteDesc , value: String(idContaCorrente + "-"  + idRegistoProduto)},
                        Correlativa_selos : {text: correlativa, value: valor, idRotulo: idRotulo},
                        ProductID: linha,
                        IDAutoDetalhe: Detalhes.autoGridSelosGarantia[i].idAutoDetalhe,
                        Discontinued: false,
                        Columns: [],
                        inEdit: false
                    })
                }
           
        }
        return data;
    }else{
         return data
    }
    
};

export const updateItem = item => {
    let index = data.findIndex(record => record.ProductID === item.ProductID);
    data[index] = item;
    return data;
};

export const deleteItem = item => {
    let index = data.findIndex(record => record.ProductID === item.ProductID);
    data.splice(index, 1);
    return data;
};
